<div class="p-(--padding-card)">
  <ces-route-title [count]="assetTypes.length">
    <ces-button [label]="'common.buttons.add' | transloco" icon="add" (onClick)="createAssetType()" />
  </ces-route-title>

  @if (loadFailed) {
    <div class="flex flex-col items-center gap-(--gap-normal) py-16 text-(--text-secondary)">
      <ces-icon size="xl" containerSize="md">error</ces-icon>
      <p>{{ 'common.errors.dataLoadFailed' | transloco }}</p>
      <ces-button [label]="'pages.errors.500.retry' | transloco" icon="refresh" (onClick)="loadData()" />
    </div>
  } @else {
    <ces-generic-parent-grid
      (createEntity)="createAssetType()"
      (deleteEntity)="deleteAssetType($event)"
      (editEntity)="editAssetType($event)"
      [dataLoadingCompleted]="dataLoadingCompleted"
      [entities]="assetTypes"
      [entityDefinition]="assetTypeDefinition" />
  }
</div>
